export const OrderRerunsEndpoints = {
  SEARCH_ORDER_RERUNS: '/api/admin/order-reruns',
};
